import { apiClient, useApiClient } from "../../shared/customHooks";
import { InviteUserForm } from "../../shared/formObjects/inviteUserForm";
import { useGlobalContext } from "../../shared/GlobalContext";
import FormContainer from "../form/FormContainer";

interface InviteUserComponentProps {
  onInvite: () => void;
  otherValues: any;
  id: string;
  label: string;
  advisory: string;
  domain?: string;
  apiClient?: apiClient;
  emailValidationMsg?: string;
}

function InviteUserComponent({ onInvite, otherValues, label, id, advisory, domain, apiClient, emailValidationMsg }: InviteUserComponentProps) {
  const api = apiClient ?? useApiClient("UserLink", { identity: true });
  const {
    accountInfo: { isManager },
  } = useGlobalContext();

  return (
    <>
      <FormContainer
        disabled={!isManager}
        id={id}
        apiClient={api}
        formBody={InviteUserForm(otherValues, label, advisory, domain, emailValidationMsg)}
        showInternalNotes={false}
        saveSuccessCB={onInvite}
        formContext={{ isProd: import.meta.env.VITE_NVI === "prod" }}
        hideCancelButton={true}
        submitBtnTitle="Submit"
      />
    </>
  );
}

export default InviteUserComponent;
